import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LearnView from "./LearnView";
import OnboardingView from "./OnboardingView";
import { cache } from "../../utils/cache";

export default function LearnController(props){
    const { t } = useTranslation();
    const [showProcessing, setShowProcessing] = useState(false);
    const { isOpen, setIsOpen } = props;
    const [openSlides, setOpenSlides] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const appConfig = cache.getAppConfig(false,true)

     return (
        <>
            <LearnView
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                showProcessing={showProcessing}
                onClose={props.onClose}
                openSlides={openSlides}
                setOpenSlides={setOpenSlides}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                appConfig={appConfig}
            />

            {openSlides && 
                <OnboardingView
                    appConfig={appConfig}
                    isOpen={openSlides}
                    setIsOpen={setOpenSlides}
                    showProcessing={showProcessing}
                    onClose={() => setOpenSlides(false)}
                    onCloseOneTap={props.onCloseAll}
                    selectedItem={selectedItem}
                />
            }

        </>
    )
}